import React, { useState } from 'react';
import { useSelector} from 'react-redux';
import { Divider, Modal, Loader, Button } from 'rsuite';
import * as actionsPayment  from '../../../../../app/actions/payment';
import {findLastUnpaidCashflow, setInstallmentText}  from '../../../../../app/common/services/vehicle.service';
import { CheckBoxCustom } from '../../elements/inputFields';
import {BackIcon, InfoIcon} from '../../svg/iconsSvg';


const PayInstConDelivery = ({onBack, onForward, policy, style}) => {

    const shipmentDetails = useSelector(state => state.shipmentDetails) || {};
    
    const unpaidCashFlow = findLastUnpaidCashflow(policy?.cashflows);

    const [trueData, setTrueData] = useState(true);
    const [assignBroker, setAssignBroker] = useState(true);
    const [showNoSuccess, setShowNoSuccess] = useState(false);
    const [showOtherBroker, setShowOtherBroker] = useState(false);

    const [loading, setLoading]   = useState(false);

    const closeModal = () => setTrueData(true);
    const closeModalNoSuccess = () => setShowNoSuccess(false);
    const closeModalOtherBroker = () => onBack(4);
    
    const goBack = () => {
        onBack(4)
    }

    const handleSubmit = async () => {

        setLoading(true);

        const cashflowId = unpaidCashFlow.cashflowId;

        let res;

        try { 
            res = await actionsPayment.payInstalmentCashOnDelivery(policy, cashflowId, shipmentDetails);
        } 
        catch (error) { console.log(error);}

        console.log(res?.data);

        if(res?.data && res?.data.status === 0) {
            onForward(8)
        } else if (res?.data && res?.data.status === 1) {
            if(res?.data?.messageCode === 'COD_FOR_3P_NOT_ALLOWED') {
                setShowOtherBroker(true);
            } else {
                setShowNoSuccess(true);
            }
            setLoading(false);
            console.log(res?.data?.message)
        }
        
    }

    return (
        <div className="steps_container" style={style}>
            <div  className="head">
                <div className="head-icon" style={{paddingLeft: '2rem'}} onClick={goBack}><BackIcon size={32}/></div>
                <h6 className="title" style={{marginRight: '48px'}}>{setInstallmentText(unpaidCashFlow)}</h6>
            </div>
            <Divider style={{marginBottom: 0 , backgroundColor: '#6bdfa7', height: '.5px'}}/>
            <div className="payment-card">
                <div className="left">
                    <p style={{marginBottom: '8px'}}>Наложен платеж</p>
                </div>
                <div className="right">
                <p style={{marginBottom: '8px', opacity: '.7'}}>Сума за плащане</p>
                <p style={{fontWeight: '700', fontSize: '15px', paddingLeft: '8px'}}>{unpaidCashFlow?.dueAmountEUR} € / {unpaidCashFlow?.dueAmount} лв.</p>
                </div>
            </div>
            
            <div className="steps_container-checkbox" style={{marginTop: '20px'}}>
                <div>
                    <InfoIcon size={22} />
                </div>
                <p style={{opacity: '.7'}}>При избран 'Наложен платеж', плащането се извършва при получаване на полицата от куриер </p>
            </div>
 
            <div className="steps_container-checkbox" style={{marginTop: '20px'}}>
                <CheckBoxCustom onChange={(data)=> setAssignBroker(data)} value={assignBroker}/>
                <p>Възлагам на БРОКЕРА извършването на посредничество във връзка с избраните от мен продукти</p>
            </div>

            <div className="steps_container-checkbox" style={{marginTop: '20px', marginBottom: '20px'}}>
                <CheckBoxCustom onChange={(data)=>setTrueData(data)} value={trueData}/>
                <p>Декларирам верността на подадените данни</p>
            </div>

            <button className="nuIns-btn nuIns-btn-mx nuIns-btn-main" type="submit" onClick={()=>handleSubmit()}>Потвърждавам</button>

            {loading ? <Loader backdrop center size="lg" speed="slow" /> : null}

            {/* Modal for true data */}
            <Modal size="xs" show={!trueData} className="nuins-ok-modal" onHide={() => closeModal()}>
                <Modal.Body >
                    <p className="no-reg-data">Не може да подадете данни с невярно съдържание</p>    
                </Modal.Body>
                <Modal.Footer >
                    <Button onClick={() => closeModal()} >OK</Button>
                </Modal.Footer>
            </Modal>
            {/* Modal for unsuccessfull cash on delivery */}
            <Modal size="xs" show={showNoSuccess} className="nuins-ok-modal" onHide={() => closeModalNoSuccess()}>
                <Modal.Body >
                    <p className="no-reg-data">Заявката е неуспешна, моля опитайте отново</p>    
                </Modal.Body>
                <Modal.Footer >
                    <Button onClick={() => closeModalNoSuccess()} >OK</Button>
                </Modal.Footer>
            </Modal>
            {/* Modal for other broker cash on delivery */}
            <Modal size="xs" show={showOtherBroker} className="nuins-ok-modal" onHide={() => closeModalOtherBroker()}>
                <Modal.Body >
                    <p className="no-reg-data">Полица, която не е издадена от нас не може да бъде платена с наложен платеж</p>    
                </Modal.Body>
                <Modal.Footer >
                    <Button onClick={() => closeModalOtherBroker()} >OK</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default PayInstConDelivery;